
import { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { FormularioCantidadColor, FormularioCantidadx10, FormularioCantidadx50, FormularioCorteVinilo, FormularioEstructuras, FormularioLitografia, FormularioPrendas, FormularioSoloCantidad } from "../../productos/formularios";
import { cantidadColor, cantidax10, cantidax50, corteVinilo, estructurasEcosolvente, litografia, nombreSoloCantidad, prendas } from "../../../data";
import { AutocompleteNombre } from "../../components";
import { useCarritoItemsStore, useGlobalValueStore, useModalStore } from "../../../stores";
import { useCategoriaSelect, useProductosXCategoria, useProductosXID } from "../../../hooks/cache";



import Swal from "sweetalert2";
import { startEditarItemsEnOps } from "../../../services";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
const createInitialValues = {
    producto: '',
    cantidad: '',
    color: '',
    talla: '',
    genero: '',
    disenio: '',
    unidadMedida: '',
    alto: '',
    ancho: '',
    terminados: '',
    totalCliente: '',
    totalDistri: '',
    totalEmpresa: '',
    totalPublicista: '',
};


export const FormCreateUpdateItem = () => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { itemActivo } = useCarritoItemsStore();
    const { view } = useGlobalValueStore();
    const { modalFormToggle } = useModalStore();
    const { data:categorias } = useCategoriaSelect();
    const [formCarrito, setFormCarrito] = useState( createInitialValues );

    const [categoriaId, setCategoriaId] = useState(null);
    const categoriaMod = categoriaId?._id || categoriaId?.id || null;
    const producID = itemActivo?.producto?._id || formCarrito.producto;
    const categoriaProduc = itemActivo?.producto?.categoria?.nombre || categoriaId?.nombre;
    const { data:prodcutosXCat } = useProductosXCategoria(categoriaMod);
    const { data:produc } = useProductosXID(producID);

    

    useEffect(() => {
        if(itemActivo) {
            setFormCarrito({ ...itemActivo, producto: itemActivo.producto._id })
        }
    }, [itemActivo]);


    const handleInputProducto = (newValor) => {
        setFormCarrito({ ...formCarrito, producto:(newValor) ? newValor.id : null });
    }


    const handleAgregarAlCarro = async() => {
        const resp = await Swal.fire({
            title: 'Modificar  OP',
            text: `¿Esta seguro de modificar este item de la op...?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si'
        });
        if( resp.value ) {
            const resp = await startEditarItemsEnOps({ ...formCarrito, carrito:itemActivo?.id, view, op:id })
            if( resp ){
                modalFormToggle(false);
                queryClient.invalidateQueries({ queryKey: ['carritoxop'] });
                queryClient.invalidateQueries({ queryKey: ['op-id'] });
            }
            
        }
    }

    

    return (

        <Box sx={{ flex:1 }}>
            <Grid container>

                {(!itemActivo) &&
                <Grid item xs={12} sx={{mt:1}}>
                    <AutocompleteNombre
                        label="Categorias"
                        placeholder='Categorias'
                        size="small"
                        name="categoriaId"
                        value={ categoriaId?._id }
                        onChange={(newValue) => setCategoriaId(newValue)}
                        options={(itemActivo) ? [itemActivo?.producto] : categorias}
                        bloqueo={!!itemActivo}
                    />
                </Grid>
                }

                {(prodcutosXCat?.length > 0 || !!itemActivo) &&
                <Grid item xs={12} sx={{mt:1}}>
                    <AutocompleteNombre
                        label="Producto"
                        placeholder='Producto'
                        size="small"
                        name="producto"
                        value={ formCarrito.producto }
                        onChange={ handleInputProducto }
                        options={itemActivo ? [itemActivo.producto] : (prodcutosXCat ?? [])}
                        bloqueo={!!itemActivo}
                    />
                </Grid>
                }

                {(nombreSoloCantidad.includes(categoriaProduc)) &&
                <FormularioSoloCantidad
                    formCarrito={formCarrito} 
                    setFormCarrito={setFormCarrito} 
                    medida={12}
                    titulo={'Editar Item'}
                    funcionAgregar={handleAgregarAlCarro}
                    poducto={ produc }
                    carrito={[]}
                />
                }

                {(cantidadColor.includes(categoriaProduc)) &&
                <FormularioCantidadColor
                    formCarrito={formCarrito} 
                    setFormCarrito={setFormCarrito} 
                    medida={12}
                    titulo={'Editar Item'}
                    funcionAgregar={handleAgregarAlCarro}
                    poducto={ produc }
                    carrito={[]}
                />
                }

                {(prendas.includes(categoriaProduc)) &&
                <FormularioPrendas
                    titulo={'Editar Item'}
                    formCarrito={formCarrito} 
                    setFormCarrito={setFormCarrito} 
                    funcionAgregar={ handleAgregarAlCarro }
                    poducto={ produc }
                    carrito={[]}
                    medida={6}
                />
                }

                {(litografia.includes(categoriaProduc)) &&
                <FormularioLitografia
                    titulo={'Editar Item'}
                    formCarrito={formCarrito} 
                    setFormCarrito={setFormCarrito} 
                    funcionAgregar={ handleAgregarAlCarro }
                    poducto={ produc }
                    carrito={[]}
                    medida={6}
                />
                }

                {(estructurasEcosolvente.includes(categoriaProduc)) &&
                <FormularioEstructuras
                    titulo={'Editar Item'}
                    formCarrito={formCarrito} 
                    setFormCarrito={setFormCarrito} 
                    funcionAgregar={ handleAgregarAlCarro }
                    poducto={ produc }
                    carrito={[]}
                    medida={6}
                />
                }

                {(cantidax10.includes(categoriaProduc)) &&
                <FormularioCantidadx10
                    titulo={'Editar Item'}
                    formCarrito={formCarrito} 
                    setFormCarrito={setFormCarrito} 
                    funcionAgregar={ handleAgregarAlCarro }
                    poducto={ produc }
                    carrito={[]}
                    medida={12}
                />
                }
                    
                {(cantidax50.includes(categoriaProduc)) &&
                <FormularioCantidadx50
                    titulo={'Editar Item'}
                    formCarrito={formCarrito} 
                    setFormCarrito={setFormCarrito} 
                    funcionAgregar={ handleAgregarAlCarro }
                    poducto={ produc }
                    carrito={[]}
                    medida={6}
                />
                }

                {(corteVinilo.includes(categoriaProduc)) &&
                <FormularioCorteVinilo
                    titulo={'Editar Item'}
                    formCarrito={formCarrito} 
                    setFormCarrito={setFormCarrito} 
                    funcionAgregar={ handleAgregarAlCarro }
                    poducto={ produc }
                    carrito={[]}
                    medida={6}
                />
                } 

            </Grid>
        </Box>
    )
}
